export default __webpack_public_path__ + "static/1.7.6/media/republicOfPoland.502b999c.svg";